import { Component, Input } from '@angular/core';
import { ButtonIconComponent } from '@mri-platform/ui-icon';
import { SvgIconName } from '@mri/elements-common';
import { KENDO_DROPDOWNBUTTON } from '@progress/kendo-angular-buttons';

export interface PageHeaderToolbarButton {
  icon?: SvgIconName;
  text: string;
  customIconUrl?: string;
  disabled?: boolean;
  title?: string;
  click: () => void;
}

@Component({
  selector: 'mri-shared-page-header-toolbar',
  standalone: true,
  imports: [ButtonIconComponent, KENDO_DROPDOWNBUTTON],
  template: `
    <!-- NOTE: Kendo dropdown cannot be used in main bundle libraries
         to avoid bloating initial bundle sizes -->
    <div class="mri-toolbar mri-page-header__page-toolbar toolbar">
      @for (toolbarButton of toolbarButtons; track $index) {
        <button
          type="button"
          class="mri-button mri-button--quiet"
          [title]="toolbarButton.title ?? toolbarButton.text"
          (click)="toolbarButton.click()"
          [disabled]="toolbarButton.disabled"
        >
          @if (toolbarButton.icon) {
            <mri-btn-icon [icon]="toolbarButton.icon"></mri-btn-icon>
          } @else if (toolbarButton.customIconUrl) {
            <svg class="mri-icon__svg mri-button__icon--left" width="28" height="12">
              <use [attr.href]="toolbarButton.customIconUrl" />
            </svg>
          }
          {{ toolbarButton.text }}
        </button>
      }
    </div>
  `,
  styleUrl: './page-header-toolbar.component.scss'
})
export class PageHeaderToolbarComponent {
  @Input() toolbarButtons?: PageHeaderToolbarButton[];
}
